<template>
  <div>
    <el-date-picker
      v-model="value"
      class="ag-table-float-el-date"
      size="mini"
      type="date"
      value-format="yyyy-MM-dd"
      prefix-icon=""
      :editable="false"
      :disabled-date="disabledDate"
      :placeholder="
        params.filterParams.opertype === 3 ? '日期搜索' : '日期过滤'
      "
      @change="handleChange"
    >
    </el-date-picker>
  </div>
</template>
<script>
export default {
  data () {
    return {
      value: ''
    }
  },
  methods: {
    disabledDate (time) {
      if (
        this.params.filterParams.disabledDate &&
        typeof this.params.filterParams.disabledDate === 'function'
      ) {
        return this.params.filterParams.disabledDate(time)
      }
      return false
    },
    handleChange () {
      if (this.value) {
        console.log(this.value)
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', this.value)
        })
      } else {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', null)
        })
      }
      if (this.params.filterParams.opertype === 3) {
        this.params.enter()
      }
    },
    onParentModelChanged (parentModel, event) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.value = ''
      } else {
        this.value = parentModel.filter
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ag-table-float-el-date {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);

  .el-input__inner {
    height: 29px;
    border-radius: 0;
    border-color: transparent;
    padding: 1px 7px !important;
    &:focus {
      border-color: #32b16c;
    }
  }
  .el-input__prefix {
    display: none;
  }
}
</style>
